import { Col } from 'antd'
import styled from 'styled-components'

export const StyledCol = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
`
